export const applicantStatsConstants = {
  GETAPPLNSTATS_REQUEST: "APPLICANT_GETAPPLNSTATS_REQUEST",
  GETAPPLNSTATS_SUCCESS: "APPLICANT_GETAPPLNSTATS_SUCCESS",
  GETAPPLNSTATS_FAILURE: "APPLICANT_GETAPPLNSTATS_FAILURE",
};
